"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
const FullStar = ({
  className
}) => /*#__PURE__*/_react.default.createElement("svg", {
  className: className,
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M18.0007 0H9.00586V18.0001H18.0007V0Z",
  fill: "#00B67B"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M9.00524 0H0V18.0001H9.00524V0Z",
  fill: "#00B67B"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M9.00575 12.1358L11.7397 11.4366L12.8771 14.9636L9.00575 12.1358ZM15.2666 7.57576H10.4771L9.00575 3.03662L7.56575 7.56533H2.70312L6.60575 10.3723L5.12401 14.8697L9.01619 12.0627L11.4162 10.3306L15.298 7.56533L15.2666 7.57576Z",
  fill: "white"
}));
FullStar.propTypes = {
  className: _propTypes.default.string
};
const HalfStar = ({
  className
}) => /*#__PURE__*/_react.default.createElement("svg", {
  className: className,
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M18.0007 0H9.00586V18.0001H18.0007V0Z",
  fill: "#DCDCE6"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M9.00524 0H0V18.0001H9.00524V0Z",
  fill: "#00B67B"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M9.00575 12.1358L11.7397 11.4366L12.8771 14.9636L9.00575 12.1358ZM15.2666 7.57576H10.4771L9.00575 3.03662L7.56575 7.56533H2.70312L6.60575 10.3723L5.12401 14.8697L9.01619 12.0627L11.4162 10.3306L15.298 7.56533L15.2666 7.57576Z",
  fill: "white"
}));
HalfStar.propTypes = {
  className: _propTypes.default.string
};
const EmptyStar = ({
  className
}) => /*#__PURE__*/_react.default.createElement("svg", {
  className: className,
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M18.0007 0H9.00586V18.0001H18.0007V0Z",
  fill: "#DCDCE6"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M9.00524 0H0V18.0001H9.00524V0Z",
  fill: "#DCDCE6"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M9.00575 12.1358L11.7397 11.4366L12.8771 14.9636L9.00575 12.1358ZM15.2666 7.57576H10.4771L9.00575 3.03662L7.56575 7.56533H2.70312L6.60575 10.3723L5.12401 14.8697L9.01619 12.0627L11.4162 10.3306L15.298 7.56533L15.2666 7.57576Z",
  fill: "white"
}));
EmptyStar.propTypes = {
  className: _propTypes.default.string
};
const TestimonialCardTrustpilotStar = ({
  rating = 4.5,
  maxStars = 5,
  starClassName = ''
}) => {
  const validRating = Math.max(0, Math.min(maxStars, rating));
  const stars = [];
  let starCounter = 0;
  const fullStars = Math.floor(validRating);
  const hasHalfStar = validRating % 1 >= 0.5;
  const emptyStars = maxStars - fullStars - (hasHalfStar ? 1 : 0);
  const getClassName = () => starCounter % 2 === 0 ? `${starClassName} star-margin` : starClassName;
  for (let i = 0; i < fullStars; i++) {
    starCounter++;
    stars.push(/*#__PURE__*/_react.default.createElement(FullStar, {
      key: `full-${i}`,
      className: getClassName()
    }));
  }
  if (hasHalfStar) {
    starCounter++;
    stars.push(/*#__PURE__*/_react.default.createElement(HalfStar, {
      key: "half",
      className: getClassName()
    }));
  }
  for (let i = 0; i < emptyStars; i++) {
    starCounter++;
    stars.push(/*#__PURE__*/_react.default.createElement(EmptyStar, {
      key: `empty-${i}`,
      className: getClassName()
    }));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "trustpilot-star",
    "data-testid": "trustpilot-star",
    className: "flex items-center"
  }, stars);
};
var _default = exports.default = TestimonialCardTrustpilotStar;